export {default as frFR} from './resources/fr-FR';



// WEBPACK FOOTER //
// ./src/translation/index.js